import { SHOP_INVENTORY_ID } from "../actionTypes";

export const currentShopInventoryIdAction = (id: string) => {
  return { type: SHOP_INVENTORY_ID, payload: id };
};
